export const buttonBase =
  'inline-flex items-center justify-center gap-2 rounded-lg heading-6 font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 text-center';

export const buttonSizes = {
  default: 'py-4 px-8',
  compact: 'py-3 px-7',
  full: 'w-full py-4 px-8',
};

export const buttonVariants = {
  primary:
    'border-2 border-primary-btn-border text-primary-btn-text bg-primary-btn-bg hover:opacity-90 focus:ring-secondary-500/30',

  secondary:
    'max-sm:w-full border-2 border-secondary-500 text-primary-500 hover:bg-secondary-500 hover:text-white focus:ring-secondary-500/30',

  heroPrimary:
    'bg-image-banner-primary-btn-bg border-2 border-image-banner-primary-btn-border text-image-banner-primary-btn-text hover:opacity-90 focus:ring-secondary-500/30',

  heroSecondary:
    'border-2 border-image-banner-secondary-btn-border text-image-banner-secondary-btn-text hover:opacity-90 hover:opacity-90 focus:ring-secondary-500/30',

  navPrimary:
    'border-2 border-nav-primary-btn-border text-nav-primary-btn-text bg-nav-primary-btn-bg hover:opacity-90 focus:ring-secondary-500/30',

  mobileRowPrimary:
    'border-2 border-brand-accent text-primary-500 hover:bg-black/5 focus:ring-secondary-500/30',

  footerMobile:
    'border-2 border-brand-accent text-white hover:opacity-90 focus:ring-secondary-500/30',
};
